import { render } from "./ColoredModal.vue?vue&type=template&id=0322275a"
import script from "./ColoredModal.vue?vue&type=script&lang=js"
export * from "./ColoredModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__